import { batch } from "react-redux";
import { params, const_var } from "../redux/reducers/reducer";
import { calcOverhangSize } from "../helpers/building_component/buildingComponent.helper.js";
import * as Constant from "../Constants/constant.js";
import * as cuComponent from "../redux/reducers/building_component/componentReducer.js";
import { resetErrMsg } from "./manufacturers_auth/login.action.js";
import axios from "axios";
import * as utils from "../redux/reducers/utils";
import * as cuBuilding from "../redux/reducers/building_pricing/pricingReducer.js";
import { onSubmitFeedback } from "../Components/Modals/validations.js";
import { buildingStyleChangeAccordingtoType, changeBuildingDimension, handleAccordionTab } from "./building/building_style/buildingStyle.action.js";
import { saveQuote } from "./share_screen/screenShare.action.js";
import { customerListService, editInventoryService, editOrderService, editQuoteService, leadListService } from "../services/quote-order.service.js";
import { getDiscount, getManufactureCount, getManufacturePricingSheet, taxFromZip } from "../services/manufacture.services.js";
import { getDealerStateList } from "./manufacturers_auth/manufacture.action.js";
import { createApiActions } from "./api/api.action.js";
import { buildingStyleChange } from "./building/building_style/buildingStyle.action.js";
import { setPricingData } from "./building_pricing/buildingPricing.action.js";
import { changeBuildingRoof } from "./building/building_style/buildingStyle.action.js";
import {
	SetBuildingAccordingToComparission,
	changeComparisonData,
	getComparisionData,
	getPricingDataForLeantoComparision,
	handleShowComparePriceModal,
	handleSummaryComapreModal,
	prepareNewBuilding,
	savePriceComparisionDataForNotLoggedIn,
	setPricingDataForLeantoComparision
} from "./building_comparison/comparison.actions.js";
import { getSidingOrientationOptions } from "../helpers/building/building_material/buildingMaterial.helper.js";
import { getBuildimgmaterial, getBuildingPricing, getNewBuildingColor } from "../services/building-service.js";
import { getBuildingPricingData } from "../helpers/building_pricing/buildingPricing.helper.js";
import { getBuildingDoorWindowPricing } from "../services/building-service.js";
import { getPricingDataforUtility } from "../helpers/building_pricing/buildingCalculation.helper.js";
import { selectLeanBuilding } from "./lean_building_pricing/api.actions.getPricingDataForLeanto.js";
import { editOldQuotes } from "../helpers/quote_order/quote.helper.js";

export {
	SetBuildingAccordingToComparission,
	changeComparisonData,
	getComparisionData,
	getPricingDataForLeantoComparision,
	handleShowComparePriceModal,
	handleSummaryComapreModal,
	prepareNewBuilding,
	savePriceComparisionDataForNotLoggedIn,
	setPricingDataForLeantoComparision
} from "./building_comparison/comparison.actions.js";

const getApiActions = () =>
	createApiActions({
		params,
		const_var,
		calcOverhangSize,
		utils,
		cuComponent,
		cuBuilding,
		Constant,
		resetErrMsg,
		handleAccordionTab,
		saveQuote,
		customerListService,
		editInventoryService,
		editOrderService,
		editQuoteService,
		leadListService,
		getManufacturePricingSheet,
		getDealerStateList,
		setQuoteStateCountForNonLoggedIn,
		setPricingData,
		setPricingDataForLeanto,
		setPricingDataForLeantoComparision,
		setPdfFile,
		discountBannerAction,
		savePriceComparisionDataForNotLoggedIn,
		handleExtraAddOnList,
		resetCheckBoxQuantityExtraBowsPrice,
		getSelectedTabstate,
		changeBuildingData,
		buildingStyleChange,
		isOpenWelcomeModal
	});

export function geDefaultBuildingDataForKlink(...args) {
	return getApiActions().geDefaultBuildingDataForKlink(...args);
}

export function geDefaultBuildingData(...args) {
	return getApiActions().geDefaultBuildingData(...args);
}

export function getPricingData(...args) {
	return getApiActions().getPricingData(...args);
}

export function getPricingDataForLeanto(...args) {
	return getApiActions().getPricingDataForLeanto(...args);
}

export function CallPublicAPI(...args) {
	return getApiActions().CallPublicAPI(...args);
}

export function sendDatatoServer(...args) {
	return getApiActions().sendDatatoServer(...args);
}

export function getBuildingData(...args) {
	return getApiActions().getBuildingData(...args);
}

export const discountApi = (...args) => getApiActions().discountApi(...args);

/****************************** Giorgi ***************************** */

export const selectCenterBuilding = () => {
	return (dispatch) => {
		dispatch({ type: "SELECT_CENTER_BUILDING" });
		dispatch({ type: "UPDATE_STATE" });
	};
};

export const setSelectedCmpType = (value) => {
	return (dispatch) => {
		dispatch({
			type: "setSelectedCmpType",
			value
		});
	};
};

export const setIsShowEditIconSection = (value) => {
	return (dispatch) => {
		dispatch({
			type: "setIsShowEditIconSection",
			value
		});
	};
};

export const setLeftWallCloseState = (value, key) => {
	return (dispatch) => {
		dispatch({
			type: "setLeftWallCloseState",
			value,
			key
		});
	};
};
export function extraItemsAction(e, condition, nextVal, index, indexName, checkIndex, extraObjectForOverhangCalculation) {
	if (checkIndex == "anchors") {
		return (dispatch) => {
			dispatch({
				type: "AdditionComponentAdd",
				value: e,
				condition: condition,
				nextVal: nextVal,
				index: index,
				indexName: indexName,
				checkIndex: checkIndex
			});
		};
	}
	if (checkIndex == "addNewComponent") {
		return (dispatch) => {
			dispatch({
				type: "AddNewComponentAdd",
				value: e,
				condition: condition,
				nextVal: nextVal,
				index: index,
				indexName: indexName,
				checkIndex: checkIndex
			});
		};
	}
	if (checkIndex == "addNewTax") {
		return (dispatch) => {
			dispatch({
				type: "addNewTax",
				value: e,
				condition: condition,
				nextVal: nextVal,
				index: index,
				indexName: indexName,
				checkIndex: checkIndex
			});
		};
	} else {
		return (dispatch) => {
			dispatch({
				type: "EXTRAELEMENTS",
				value: e,
				condition: condition,
				nextVal: nextVal,
				index: index,
				indexName: indexName,
				checkIndex: checkIndex,
				extraObjectForOverhangCalculation: extraObjectForOverhangCalculation
			});
		};
	}
}
export function handleInsulation(e, condition, _type, isValSel) {
	return (dispatch) => {
		dispatch({
			type: "handleInsulation",
			value: e,
			condition: condition,
			_type: _type,
			isValSel: isValSel
		});
	};
}

export const setWallCloseStateWrap = (value) => {
	return (dispatch) => {
		dispatch({
			type: "setWallCloseStateWrap",
			value
		});
	};
};

export const changeLeanDragState = (isDrag) => {
	return (dispatch) => {
		dispatch({
			type: "changeLeanDragState",
			isDrag
		});
	};
};

export const setMainTrussPosInfo = (value) => {
	return (dispatch) => {
		dispatch({
			type: "setMainTrussPosInfo",
			value
		});
	};
};

export const setTrussTypeName = (value) => {
	return (dispatch) => {
		dispatch({
			type: "setTrussTypeName",
			value
		});
	};
};

export const setLeanToTrussPosInfo = (value) => {
	return (dispatch) => {
		dispatch({
			type: "setLeanToTrussPosInfo",
			value
		});
	};
};

export const updateLeanToPosition = (name, position) => {
	return (dispatch) => {
		dispatch({
			type: "updateLeanToPosition",
			name,
			position
		});
	};
};

export const updateDoorWindowsArray = (newArray, isChk) => {
	return (dispatch) => {
		dispatch({
			type: "updateDoorWindowsArray",
			newArray,
			isChk: isChk
		});
	};
};

export const updateDoorWindowPosition = (doorUniqueId, positionX, positionY) => {
	return (dispatch) => {
		dispatch({
			type: "updateDoorWindowPosition",
			doorUniqueId,
			positionX,
			positionY
		});
	};
};

export const onDragUtilityPriceReset = (value) => {
	return (dispatch) => {
		dispatch({
			type: "onDragUtilityPriceReset",
			val: value
		});
	};
};

export const updateEndStoragePositionZ = (positionZ, startPositionZ, isDrag) => {
	return (dispatch) => {
		dispatch({
			type: "updateEndStoragePositionZ",
			positionZ,
			startPositionZ,
			isDrag
		});
	};
};

export const updateLeftLeanStoragePosition = (positionZ, startPosition, isDrag) => {
	return (dispatch) => {
		dispatch({
			type: "updateLeftLeanStoragePosition",
			positionZ,
			startPosition,
			isDrag
		});
	};
};

export const updateRightLeanStoragePosition = (positionZ, startPosition, isDrag) => {
	return (dispatch) => {
		dispatch({
			type: "updateRightLeanStoragePosition",
			positionZ,
			startPosition,
			isDrag
		});
	};
};

export const updateFrontLeanStoragePosition = (positionX, startPosition, isDrag) => {
	return (dispatch) => {
		dispatch({
			type: "updateFrontLeanStoragePosition",
			positionX,
			startPosition,
			isDrag
		});
	};
};

export const updateBackLeanStoragePosition = (positionX, startPosition, isDrag) => {
	return (dispatch) => {
		dispatch({
			type: "updateBackLeanStoragePosition",
			positionX,
			startPosition,
			isDrag
		});
	};
};

export const updateDoorWindowLimitPosition = (doorUniqueId, minLimitX, maxLimitX) => {
	return (dispatch) => {
		dispatch({
			type: "updateDoorWindowLimitPosition",
			doorUniqueId,
			minLimitX,
			maxLimitX
		});
	};
};

export const changeDoorWindowSize = (compType, compName, width, height, wallName, parentkey, childkey, nestedkey, positionX, positionY, sideArray, doorUniqueId) => {
	return (dispatch) => {
		dispatch({
			type: "changeDoorWindowSize",
			compType,
			compName,
			width,
			height,
			wallName,
			parentkey,
			childkey,
			nestedkey,
			positionX,
			positionY,
			sideArray,
			doorUniqueId
		});
	};
};

export const updateCupolas = (uniqueId, positionZ) => {
	return (dispatch) => {
		dispatch({
			type: "updateCupolas",
			uniqueId,
			positionZ
		});
	};
};

export const updateCupolasArray = (newArray) => {
	return (dispatch) => {
		dispatch({
			type: "updateCupolasArray",
			newArray
		});
	};
};

export const updateChangeSizeType = (doorUniqueId, isCustomSizeChange) => {
	return (dispatch) => {
		dispatch({
			type: "updateChangeSizeType",
			doorUniqueId,
			isCustomSizeChange
		});
	};
};

export function removeComponent(uniqueId, component_name, uniqueindex, isDropdownChange = false) {
	return (dispatch) => {
		dispatch({
			type: "removeComponent",
			uniqueId: uniqueId,
			isDropdownChange: isDropdownChange
		});
	};
}

export const showAlert = (alertText, doorUniqueId) => {
	return (dispatch) => {
		dispatch({
			type: "showAlert",
			alertText,
			doorUniqueId
		});
	};
};

export const setActiveBuildingWall = (value) => {
	return (dispatch) => {
		dispatch({
			type: "setActiveBuildingWall",
			value: value
		});
	};
};

export function handleActiveWallSubTab(value) {
	return (dispatch) => {
		dispatch({
			type: "handleActiveWallSubTab",
			value: value
		});
	};
}

export function handleIsResetBuildingState() {
	return (dispatch) => {
		dispatch({
			type: "handleIsResetBuildingState"
		});
	};
}

export const setLeanToLegPosObj = (value, key) => {
	return (dispatch) => {
		dispatch({
			type: "setLeanToLegPosObj",
			value: value,
			key: key
		});
	};
};

export const setQuoteStateCountForNonLoggedIn = (data, stateList) => {
	return (dispatch) => {
		const stateId = data?.request_data?.building.state;
		const selectedState = stateList != undefined && stateList.find((state) => state.id == stateId);
		if (selectedState && selectedState?.manufacturer_list?.price_comparision?.length > 0) {
			const key = `selectedState_${stateId}`;
			dispatch(savePriceComparisionDataForNotLoggedIn(key, selectedState?.manufacturer_list?.price_comparision));
		}
	};
};

function calculateDistance(d1, d2) {
	return Math.sqrt(Math.pow(d1.width - d2.width, 2) + Math.pow(d1.height - d2.height, 2) + Math.pow(d1.length - d2.length, 2));
}

export const discountBannerAction = (disResp, forAll, msnID, isComp = false) => {
	return (dispatch) => {
		dispatch({
			type: "discountBannerAction",
			value: disResp,
			forAll: forAll,
			msnID: msnID,
			isComp: isComp
		});
	};
};

export function setPdfFile(dispatch, mfgId) {
	const manufacture_id = params.m_s_n;
	const state_id = params.p_s_n;
	const manufactureKey = const_var.stateManufactureDataFromApi.find((item) => item.id == state_id).manufacturer_list.find((m) => m.id === manufacture_id).u_id;
	params.manufactureKey = manufactureKey;
	getManufacturePricingSheet(const_var.crmSetting.api_token, params.manufactureKey)
		.then((response) => {
			if (response?.data?.length > 0) {
				const baseUrl = const_var.crmSetting.api_post_url;
				const updatedData = response.data.map((item) => ({
					...item,
					path: `${baseUrl}/${item.path}`
				}));
				let checkResp = updatedData.filter((item) => item.file_name != "" && !item.file_name.includes(".html"));
				if (checkResp.length > 0) {
					dispatch({
						type: "handlePriceBookFile",
						value: updatedData
					});
				}
			} else {
				dispatch({
					type: "handlePriceBookFile",
					value: ""
				});
			}
		})
		.catch((error) => {
			console.log(error);
		});
}

export const getManufacturerStateQuoteForNonLoggedIn = async (manufactureId, selectedStateId) => {
	const providers = const_var.stateManufactureDataFromApi.find((state) => state.id === params.p_s_n).manufacturer_list;
	const stateId = providers?.find((p) => p.id === manufactureId)?.u_id;
	const response = await getManufactureCount(stateId);
	return response?.data ?? null;
};

function resetCheckBoxQuantityExtraBowsPrice() {
	const_var.ExtraItemsFeaturesQuantityArray.length > 0 &&
		const_var.ExtraItemsFeaturesQuantityArray.map((checkBoxQuantity) => {
			if (checkBoxQuantity && checkBoxQuantity.name == "bows") {
				if (
					const_var.UpdatedPriceData["elements"] != undefined &&
					const_var.UpdatedPriceData["elements"][checkBoxQuantity.label?.toString()] != undefined &&
					const_var.UpdatedPriceData["elements"][checkBoxQuantity.label.toString()].is_edit == true
				) {
					checkBoxQuantity.is_edit = false;
					const_var.UpdatedPriceData["elements"][checkBoxQuantity.label.toString()].is_edit = false;
				}
			}
		});
}

export function updateEditIconVisiblity() {
	return (dispatch) => {
		dispatch({
			type: "updateEditIconVisiblity"
		});
	};
}

export function changeBuildingData(apiResponse) {
	return {
		type: "CHANGEBUILDINGDATA",
		value: apiResponse
	};
}
export function CheckOtherBuildingType(value, defaultVal) {
	return {
		type: "CheckOtherBuildingType",
		value: value,
		defaultVal: defaultVal
	};
}
export function CheckDoorWindowsInstallationFees(response) {
	return {
		type: "CheckDoorWindowsInstallationFees",
		value: response
	};
}
export function setPricingDataForLeanto(apiResponse, type) {
	const_var.UpdatedPriceData.truss_price_changed = true;
	return {
		type: "SETPRICINGDATAFORLEANTO",
		value: apiResponse,
		str: type
	};
}

export function pricingLoaderFalse() {
	return {
		type: "PRICINGLOADERFALSE"
	};
}

export function handleExtraAddOnList(updatedList) {
	return {
		type: "handleExtraAddOnList",
		value: updatedList
	};
}

export function roofColorChange(str, a) {
	return (dispatch) => {
		dispatch({ type: "COLOR", value: a, str: str });
	};
}

export function buildingSurfaceChange(val, label) {
	return (dispatch) => {
		dispatch({ type: "SURFACECHANGE", value: val, label: label });
	};
}
export function setZipCodeVal(val, key) {
	return (dispatch) => {
		dispatch({
			type: "setZipCodeVal",
			value: val,
			key: key
		});
	};
}
export function roofStyleChange(val) {
	return (dispatch) => {
		dispatch({ type: "ROOFSTYLECHANGE", value: val });
	};
}

export function changePorchDimension(val, str, checkLean, checkCustomDimension, secondParam) {
	return (dispatch) => {
		batch(() => {
			dispatch({
				type: "CHANGEPORCHDIMENSION",
				value: val,
				str: str,
				secondParam: secondParam == undefined ? undefined : secondParam,
				checkCustomDimension: checkCustomDimension == undefined ? undefined : checkCustomDimension
			});
		});
	};
}

export function makeDimensionUpdate() {
	return (dispatch) => {
		dispatch({
			type: "makeDimensionUpdate"
		});
	};
}
export function getSelectedTab(key) {
	return (dispatch) => {
		batch(() => {
			if (key == "capture") {
				dispatch(handleCloseforDoorWindows(1));
			}
			dispatch({
				type: "SELECTED_TAB",
				key: key
			});
		});
	};
}
export function toggleFullyOpenedCheckboxChange(e, str) {
	return (dispatch) => {
		dispatch({
			type: "FULLYOPENED",
			event: e,
			value: str
		});
	};
}
export function toggleFullyEnclosedCheckboxChange(e, str) {
	return (dispatch) => {
		dispatch({
			type: "FULLYENCLOSED",
			event: e,
			value: str
		});
	};
}

// for state change tab

export function getSelectedTabstate(key, setPreStateOnly = false, resetErrorMsg = false) {
	const removea = document.querySelector("body");
	removea.classList.remove("active-total-price");
	const_var.showReportLoading = false;
	if (!const_var.loginSession) {
		const_var.crmSetting.is_Edit = false;
	}

	if (setPreStateOnly == true || const_var.isKLinkEnable == true) {
		const_var.showStateOnly = true;
		const_var.apiCalledforState = false;
	}
	if (key == "statechange") {
		const_var.isFromStateChange = true;
	}
	return (dispatch) => {
		if (resetErrorMsg == true) {
			dispatch(resetErrMsg());
		}
		dispatch({
			type: "SELECTED_TAB_STATE",
			key: key
		});
	};
}
export function toggleAllVerticalCheckboxChange(key, makeValueChange = undefined /* false */) {
	return (dispatch) => {
		dispatch({
			type: "ALLVERTICAL",
			key: key,
			makeValueChange: makeValueChange
		});
		const_var.UpdatedPriceData.insulation_price_changed = undefined;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_utility_price_changed = true;
		const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		utils.update26GAUpgradePrice();
		if (params.add_left_lean && const_var.isLTBuilding && params.leanStyle.left === "gable") {
			utils.update26GAUpgradePrice("left");
		}
		if (params.add_right_lean && const_var.isLTBuilding && params.leanStyle.right === "gable") {
			utils.update26GAUpgradePrice("right");
		}
		if (params.add_front_lean && const_var.isLTBuilding && params.leanStyle.front === "gable") {
			utils.update26GAUpgradePrice("front");
		}
		if (params.add_back_lean && const_var.isLTBuilding && params.leanStyle.back === "gable") {
			utils.update26GAUpgradePrice("back");
		}
		dispatch(getPricingData());
	};
}
export function APICalledForState(value) {
	return (dispatch) => {
		dispatch({
			type: "APICalledForState",
			value: value
		});
	};
}
export function toggleCutPanelsCheckboxChange(key, value) {
	return (dispatch) => {
		dispatch({
			type: "CUTPANELACTION",
			key: key,
			value: value
		});
	};
}
export function handleWallSelectonChangeValue(e, wall) {
	return (dispatch) => {
		dispatch({
			type: "INDUVIDUALWALLCHANGE",
			value: e,
			wall: wall
		});
	};
}
export function updateWainscot() {
	return (dispatch) => {
		dispatch({
			type: "ADDWAINSCOT"
		});
	};
}
export function trussChange(trussName) {
	return (dispatch) => {
		dispatch({
			type: "TRUSSCHANGEFUNCTION",
			value: trussName
		});
	};
}

export function selectedTrussForLean(truss, leanType) {
	return (dispatch) => {
		const_var.is_loader = true;
		dispatch({
			type: "SELECT_TRUSS_FOR_LEAN",
			truss: truss,
			leanType: leanType
		});
		setTimeout(() => {
			const_var.is_loader = false;
			dispatch({ type: "UPDATE_STATE" });
		}, 300);
	};
}

export function handleCanopyCheckboxChange(e) {
	return (dispatch) => {
		dispatch({
			type: "handleCanopyCheckboxChange",
			value: e
		});
	};
}
export function handleCupola(e, option, uniqueId, cupola) {
	return (dispatch) => {
		dispatch({
			type: "handleCupola",
			value: e,
			option: option,
			uniqueId: uniqueId,
			cupola: cupola
		});
	};
}
export function setPriceForCupola(flag, length) {
	return {
		type: "setPriceForCupola",
		flag: flag,
		length: length
	};
}

export function cetificateChange(e, val, other) {
	return (dispatch) => {
		dispatch({
			type: "PRICEDATACERTIFICATION",
			value: e,
			str: val,
			other: other
		});
	};
}
export function handleLiftRequired(val) {
	return (dispatch) => {
		dispatch({
			type: "handleLiftRequired",
			value: val
		});
	};
}
export function handleInsulationFor(key, value, _type = undefined) {
	return (dispatch) => {
		dispatch({
			type: "handleInsulationFor",

			key: key,
			isfor: _type
		});

		if (_type != undefined) {
			dispatch({
				type: "handleInsulation",
				value: value,
				condition: "custom",
				_type: _type,
				isValSel: undefined
			});
		} else {
			dispatch({
				type: "EXTRAELEMENTS",
				value: "Custom",
				condition: "custom",
				nextVal: undefined,
				index: undefined,
				indexName: undefined,
				checkIndex: undefined,
				isInsChange: true
			});
		}
	};
}


export function confirmStateAction(e) {
	return (dispatch) => {
		dispatch({
			type: "confirmStateAction",
			value: e
		});
	};
}

export function extraInformationAction(e, condition) {
	return (dispatch) => {
		dispatch({
			type: "EXTRAINFORMATION",
			value: e,
			condition: condition
		});
	};
}
export function handleLeanToWallSelectonChangeValue(e, wall, typeofLean) {
	return (dispatch) => {
		dispatch({
			type: "INDUVIDUALLEANTOWALLCHANGE",
			value: e.target.value,
			wall: wall,
			typeofLean: typeofLean
		});
	};
}
export function toggleAddUtilityCheckboxChange(e, storage, incloseVal) {
	return (dispatch) => {
		batch(() => {
			utils.update26GAUpgradePrice();
			dispatch({
				type: "ADDUTILITY",
				value: e.target.value,
				storage: storage
			});
			if (params.p_u_c == true || params.cB_addStorage_check_front) {
				dispatch(getPricingDataforUtility(e));
			}
			if (storage == "both") {
				dispatch(getPricingDataforUtility(e, "left_combo", params.cB_addStorage_left));
				dispatch(getPricingDataforUtility(e, "right_combo", params.cB_addStorage_right));
			}
			if (storage == "bothside_with_back") {
				dispatch(getPricingDataforUtility(e));
				dispatch(getPricingDataforUtility(e, "left_combo", params.cB_addStorage_left));
				dispatch(getPricingDataforUtility(e, "right_combo", params.cB_addStorage_right));
			}
			if (params.cB_addStorage_check_left == true) {
				incloseVal = params.cB_addStorage_left;
				dispatch(getPricingDataforUtility(e, "left_combo", incloseVal));
			}
			if (params.cB_addStorage_check_right == true) {
				incloseVal = params.cB_addStorage_right;
				dispatch(getPricingDataforUtility(e, "right_combo", incloseVal));
			}
			const_var.UpdatedPriceData.height_price_changed = true;
		});
	};
}
export function nostorage(e, val) {
	let chkSideCombo = false;
	return (dispatch) => {
		if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) {
			chkSideCombo = true;
		}
		dispatch({
			type: "NOSTORAGE",
			event: e,
			val: val
		});
		if (chkSideCombo == true) {
			if (const_var.crmSetting.is_Edit) {
				const_var.UpdatedPriceData.left_wall_price_changed = true;
				const_var.UpdatedPriceData.right_wall_price_changed = true;
			}
			dispatch(getPricingData(false));
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
		}
	};
}
export function toggleAddUtilityCheckboxChangeForFront(isLengthChange = false) {
	return (dispatch) => {
		dispatch({
			type: "ADDUTILITYFRONT",
			isLengthChange: isLengthChange
		});
	};
}
export function toggleAddUtilityCheckboxChangeForBack(isLengthChange = false) {
	return (dispatch) => {
		dispatch({
			type: "ADDUTILITYBACK",
			isLengthChange: isLengthChange
		});
	};
}
export function toggleAddUtilityCheckboxChangeForLeft(isLengthChange = false) {
	return (dispatch) => {
		dispatch({
			type: "ADDUTILITYLEFT",
			isLengthChange: isLengthChange
		});
	};
}
export function toggleAddUtilityCheckboxChangeForRight(isLengthChange = false) {
	return (dispatch) => {
		dispatch({
			type: "ADDUTILITYRIGHT",
			isLengthChange: isLengthChange
		});
	};
}

export function handleUtilityLenghtSelectonChangeValue(e, str) {
	return (dispatch) => {
		dispatch({
			type: "UTILITYLENGHTCHANGE",
			value: e,
			str: str
		});
	};
}

export function handleUtilityLenghtSelectonChangeValueCB(e, str) {
	return (dispatch) => {
		dispatch({
			type: "UTILITYLENGHTCHANGECB",
			value: e,
			str: str
		});
	};
}

export function handleUtilityLenghtSelectonChangeValueCBL(e, str) {
	return (dispatch) => {
		dispatch({
			type: "UTILITYLENGHTCHANGECBL",
			value: e,
			str: str
		});
	};
}

export function alertCancel(alertUsedFor) {
	return (dispatch) => {
		dispatch({
			type: "alertCancel",
			alertUsedFor: alertUsedFor
		});
	};
}
export function commonActionCall(e, key) {
	return {
		type: "commonActionCall",
		value: e,
		key: key
	};
}
export function alertDone(alertUsedFor) {
	return (dispatch) => {
		if (const_var.alertUsedFor == "CancelOrderQuote") {
			if (const_var.oldFreeStandingData !== undefined) {
				editOldQuotes(const_var.oldFreeStandingData);
			}
			let dwIconsDiv = document.getElementById("doorwindowicons");
			dwIconsDiv && dwIconsDiv.classList.add("d-none");
			let snowValChk = const_var.CheckSnowLoadValue == 65 ? 1 : 0;
			let filterResult = const_var.AllBuildingData.data.default_building.filter((data) => data.heavy_snow == snowValChk && data.image_name.includes("Garages.png"));
			if (filterResult.length == 0) {
				filterResult = const_var.AllBuildingData.data.default_building.filter((data) => data.heavy_snow == snowValChk && data.name.includes("RV Covers"));
			}

			if (const_var.BuldingIDforReset != undefined) {
				const_var.isCheckColoredScrews = params.m_s_n == 167 || params.m_s_n == 184 ? true : false;
				dispatch(buildingStyleChange(const_var.BuldingIDforReset, []));
				if (const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined) {
					const_var.stateManufacturerAcordingAPI[params.p_s_n].map((data) => {
						const_var.dealer_discount_label = "";
						const_var.manufacturer_discount_label = "";
						params.display_product_status = "in_stock";
						params.isShowCenter = false;
						const_var.isAutoRotate = false;
						const_var.insideoutside = false;
						const_var.controls.autoRotate = false;
						let defaultEDItem =
							const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].drawings != undefined && const_var.c_m_a[params.p_b_t].drawings.length > 0
								? const_var.c_m_a[params.p_b_t].drawings.filter((obj) => obj.is_default == "yes")
								: [];
						const_var.i_g_A_y = [];
						if (const_var.crmSetting.form_action == "edit") {
							const_var.checkCaptuareImage = false;
						}
						document.querySelector("body").classList.remove("activebuildingbg");
						document.querySelector("body").classList.remove("active-fullview");
						const_var.isfullviewbuilding = false;
						const_var.crmSetting.is_show_background = false;
						const_var.is_edit_labour = undefined;
						const_var.selected_scbracing = "";
						const_var.selected_ecbracing = "";
						const_var.selectedBracingForAddedBuilding = {
							left_lean_end: "",
							left_lean_side: "",
							right_lean_end: "",
							right_lean_side: "",
							front_lean_end: "",
							front_lean_side: "",
							back_lean_end: "",
							back_lean_side: ""
						};
						const_var.selSidingOption = "metal";
						const_var.selSidingObj = {
							name: "metal",
							label: "Metal",
							price_type: "$",
							price_of: [],
							panel_price_from: ["vertical"],
							panel_orientation: ["horizontal", "vertical"],
							cost: 0
						};
						params.wallOrientation = "horizontal";
						const_var.sidingOrientationOptions = getSidingOrientationOptions();
						if (params.p_w > 32 && const_var.b_o_J_1[params.p_b_t] != "Custom Buildings") {
							params.p_v_w = params.m_s_n != "75" ? true : false;
							if (params.p_v_w) {
								params.wallTexture = "vertical";
								params.wallOrientation = "vertical";
								params.wainscotTexture = "vertical";
							} else {
								params.wallTexture = "none";
								params.wainscotTexture = "none";
							}
						} else {
							params.p_v_w = false;
							params.wallTexture = "none";
							params.wainscotTexture = "none";
						}

						if (data.id == params.m_s_n) {
							const_var.order_extra_items = {
								job_site_level: "",
								inside_city: "",
								installation_ready: "",
								surface_level: "",
								electricity: "",
								welded_spacer: "",
								notched_lip: "",
								space_around_building: "",
								site_clear_obstacle: "",
								order_permit_fee: data.order_permit_fee,
								permit: params.m_s_n == 67 ? "cust_verify" : "yes",
								includeIn: "",
								equipment_rental: 0,
								document_fee: data.document_fee,
								order_processing_fee: data.order_processing_fee,
								surchargeFees: data.surchargeFees,
								delivery_fee: 0,
								engineer_drawings: defaultEDItem.length > 0 ? defaultEDItem.cost : 0,
								freight: 0,
								extra_labour: data.labor_fee,
								labor_fee_on: data.labor_fee_on,
								labor_per_type: data.labor_fee,
								processing_fee: 0,
								concrete_work: 0,
								ground_work: 0,
								grvy_value: 0,
								has_grvy: 0,
								pdf_price_breakdown: const_var.price_breakdown_key[const_var.crmSetting.is_module_name],
								dont_show_processing_fee_pdf: 1,
								engineer_drawings_name: defaultEDItem.length > 0 ? defaultEDItem.name : ""
							};
						}
					});
					dispatch(handleIsResetBuildingState());
					dispatch(handleAccordionTab("", "buildingtypetab", "reset"));
				}
			}
		}
		//This code is for custom building
		if (const_var.alertUsedFor == "customBuildings") {
			const_var.dealer_discount_label = "";
			const_var.manufacturer_discount_label = "";
			if (const_var.checkmoreCustomizeFlag != undefined && const_var.checkmoreCustomizeFlag == false) {
				let cutomBuildingData = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype.name.includes("Custom Buildings"));
				dispatch(buildingStyleChangeAccordingtoType(cutomBuildingData[0].id, cutomBuildingData[0].other_building_id.split(",")));
				if (const_var.accodionEvent != undefined) {
					const_var.accodionEvent.remove("active");
				}
				if (const_var.loginSession == false) {
					const_var.hide_price_calculation = 1;
					document.querySelector("body").classList.add("active-hidden-price");
				}
				const_var.eventKey = "customizations";
			} else {
				const_var.isCheckColoredScrews = params.m_s_n == 167 || params.m_s_n == 184 ? true : false;
				let cutomBuildingData = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype.name.includes("Garage"));
				dispatch(buildingStyleChangeAccordingtoType(cutomBuildingData[0].id, cutomBuildingData[0].other_building_id.split(",")));
				if (const_var.loginSession == false && const_var.stateData != undefined) {
					const_var.hide_price_calculation = const_var.stateData.hide_price_calculation;
					document.querySelector("body").classList.remove("active-hidden-price");
				}
				if (const_var.accodionEvent != undefined) {
				}
				const_var.eventKey = "garages";
			}
		}
		if (const_var.alertUsedFor == "ManageKlinkMessage") {
			dispatch({
				type: "GenrateBuildingDatatoServer",
				event: "",
				key: "genrate"
			});
		}
		if (const_var.alertUsedFor == "YourCanNotAddLeanTo") {
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;

			if (
				(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
				(params.p_f_w.toLowerCase() == "one_fourth_close" || params.p_f_w.toLowerCase() == "three_fourth_close" || params.p_f_w.toLowerCase() == "half_close")
			) {
				params.p_f_w = "Open";
			}

			if (
				(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
				(params.p_b_w.toLowerCase() == "one_fourth_close" || params.p_b_w.toLowerCase() == "three_fourth_close" || params.p_b_w.toLowerCase() == "half_close")
			) {
				params.p_b_w = "Open";
			}
			dispatch(getPricingData(undefined, params.p_h, "h"));
		}
		if (const_var.alertUsedFor == "YouCanNotAddPorch" || const_var.alertUsedFor == "YourCanNotAddPorch" || const_var.alertUsedFor == "YourCanNotAlignPorch" || const_var.alertUsedFor == "YourCanNotChangePorch") {
			dispatch(fullyWrapClick(false));
			if (params.preAction.type === "changeBuildingRoof") {
				changeBuildingRoof({ ...params.preAction, skipCheck: true })(dispatch);
			} else if (params.preAction.type === "CHANGEDIMENSION") {
				changeBuildingDimension({ ...params.preAction, skipCheck: true })(dispatch);
			} else if (params.preAction.type === "changeLeantoPosition") {
				changeLeantoPosition({ ...params.preAction, skipCheck: true })(dispatch);
			}
			dispatch(
				handleLeanPorchPrices(
					params.params_cancel.add_left_front_lean_porch,
					params.params_cancel.add_right_front_lean_porch,
					params.params_cancel.add_left_back_lean_porch,
					params.params_cancel.add_right_back_lean_porch
				)
			);
		}
		if (const_var.alertUsedFor == "changeInstallationSurface") {
			cuComponent.removeAlltheComponent(true);
			dispatch(buildingSurfaceChange(const_var.installation_surface));
		}
		dispatch({
			type: "alertDone",
			alertUsedFor: alertUsedFor
		});
	};
}

export function handleClose() {
	return (dispatch) => {
		dispatch({
			type: "handleClose"
		});
	};
}

export function handleAccordion(event, key) {
	return (dispatch) => {
		dispatch({
			type: "handleAccordion",
			value: event,
			key: key
		});
	};
}

export function DeviceCapture(key, id) {
	return (dispatch) => {
		dispatch({
			type: "DeviceCapture",
			key: key,
			id: id
		});
	};
}

export function handleCloseforDoorWindows(uniqueid, doorIndex, entryNoteDataValue) {
	return (dispatch) => {
		dispatch({
			type: "handleCloseforDoorWindows",
			uniqueid,
			doorIndex,
			entryNoteDataValue
		});
	};
}

export function hancleClickOutside() {
	return (dispatch) => {
		dispatch({
			type: "hancleClickOutside"
		});
	};
}
export function handleSidePanel(e, isActiveSlide) {
	return (dispatch) => {
		dispatch({
			type: "handleSidePanel",
			event: e,
			isActiveSlide: isActiveSlide
		});
	};
}
export function handleCloseBuildingModal() {
	return (dispatch) => {
		dispatch({
			type: "handleCloseBuildingModal"
		});
	};
}
export function handleShowWhatThis(str, id) {
	return (dispatch) => {
		dispatch({
			type: "handleShowWhatThis",
			value: str,
			id: id
		});
	};
}

export function handleShowfeedback(category, e, typen) {
	if (category == "submit") {
		onSubmitFeedback();

		let userObj = "";
		if (localStorage.getItem("userData") != undefined) {
			userObj = JSON.parse(localStorage.getItem("userData"));
		}

		let postData = {};
		if (const_var.loginSession == true) {
			if (const_var.isFeedbackFieldMandatory == true) {
				postData = {
					user_name: const_var.feedback_object_to_server.first_name + " " + const_var.feedback_object_to_server.last_name,
					user_email: const_var.feedback_object_to_server.feedback_email,
					company_name: userObj.company_name,
					like_status: const_var.feedback_object_to_server.like_count,
					feedback: const_var.feedback_object_to_server.feedback,
					api_token: const_var.crmSetting.api_token,
					domain_url: window.location.href,
					user_id: const_var.crmSetting.login_user_id,
					phone_number: const_var.feedback_object_to_server.phone_number
				};
			} else {
				let user_name = userObj.first_name + " " + userObj.last_name;
				let user_email = userObj.email;
				let phone_number = "";
				if (const_var.feedback_object_to_server != undefined && (const_var.feedback_object_to_server.first_name != "" || const_var.feedback_object_to_server.last_name != "")) {
					user_name = const_var.feedback_object_to_server.first_name + " " + const_var.feedback_object_to_server.last_name;
				}

				if (const_var.feedback_object_to_server && const_var.feedback_object_to_server.feedback_email != "") {
					user_email = const_var.feedback_object_to_server.feedback_email;
				}
				if (const_var.feedback_object_to_server && const_var.feedback_object_to_server.phone_number != "") {
					phone_number = const_var.feedback_object_to_server.phone_number;
				}
				postData = {
					user_name: userObj.first_name + " " + userObj.last_name,
					user_email: userObj.email,
					company_name: userObj.company_name,
					like_status: const_var.feedback_object_to_server.like_count,
					feedback: const_var.feedback_object_to_server.feedback,
					api_token: const_var.crmSetting.api_token,
					domain_url: window.location.href,
					user_id: const_var.crmSetting.login_user_id,
					phone_number: phone_number
				};
			}
		} else {
			if (const_var.isFeedbackFieldMandatory == true) {
				postData = {
					user_name: const_var.feedback_object_to_server.first_name + " " + const_var.feedback_object_to_server.last_name,
					user_email: const_var.feedback_object_to_server.feedback_email,
					company_name: userObj.company_name,
					like_status: const_var.feedback_object_to_server.like_count,
					feedback: const_var.feedback_object_to_server.feedback,
					api_token: const_var.crmSetting.api_token,
					domain_url: window.location.href,
					user_id: null,
					phone_number: const_var.feedback_object_to_server.phone_number
				};
			} else {
				let user_name = "estimator visitor";
				let user_email = "visitor@estimator.com";
				let phone_number = "";

				if (const_var.feedback_object_to_server != undefined && (const_var.feedback_object_to_server.first_name != "" || const_var.feedback_object_to_server.last_name != "")) {
					user_name = const_var.feedback_object_to_server.first_name + " " + const_var.feedback_object_to_server.last_name;
				}

				if (const_var.feedback_object_to_server && const_var.feedback_object_to_server.feedback_email != "") {
					user_email = const_var.feedback_object_to_server.feedback_email;
				}
				if (const_var.feedback_object_to_server && const_var.feedback_object_to_server.phone_number != "") {
					phone_number = const_var.feedback_object_to_server.phone_number;
				}
				postData = {
					user_name: user_name,
					user_email: user_email,
					company_name: const_var.crmSetting.company_name,
					like_status: const_var.feedback_object_to_server.like_count,
					feedback: const_var.feedback_object_to_server.feedback,
					api_token: const_var.crmSetting.api_token,
					domain_url: window.location.href,
					user_id: null,
					phone_number: phone_number
				};
			}
		}

		return (dispatch) => {
			dispatch({
				type: "handleShowfeedback",
				category: "validation"
			});

			if (
				(const_var.displayerrorMessage.feedback == "" &&
					const_var.displayerrorMessage.feedback_phone_number == "" &&
					const_var.displayerrorMessage.feedback_email == "" &&
					const_var.isFeedbackFieldMandatory == false) ||
				(const_var.isFeedbackFieldMandatory == true &&
					const_var.displayerrorMessage.feedback_first_name == "" &&
					const_var.displayerrorMessage.feedback_last_name == "" &&
					const_var.displayerrorMessage.feedback_phone_number == "" &&
					const_var.displayerrorMessage.feedback_email == "")
			) {
				dispatch({
					type: "handleShowfeedback",
					category: "handleShowfeedbackloader"
				});
				return axios.post(const_var.crmSetting.api_post_url + "/api/v1/3d/send_feedback", postData).then(function (response) {
					if (response.data.status == true) {
						dispatch({
							type: "handleShowfeedback",
							category: "success"
						});
					}
				});
			}
		};
	} else {
		return (dispatch) => {
			dispatch({
				type: "handleShowfeedback",
				category: category,
				event: e,
				typen: typen
			});
		};
	}
}

export function handleShowsummarymodal(str, id) {
	return (dispatch) => {
		dispatch({
			type: "handleShowsummarymodal",
			value: str,
			id: id
		});
	};
}

export function handleScreenShareModal(str, id) {
	return (dispatch) => {
		dispatch({
			type: "handleScreenShareModal",
			value: str,
			id: id
		});
	};
}

export function handleShowPhotoModal(str, id) {
	return (dispatch) => {
		dispatch({
			type: "handleShowPhotoModal",
			value: str,
			id: id
		});
	};
}

export function handleShowDiscountsPanel() {
	return (dispatch) => {
		dispatch({
			type: "handleShowDiscountsPanel"
		});
	};
}

export function handleShowDiscountsModal() {
	return (dispatch) => {
		dispatch({
			type: "handleShowDiscountsModal"
		});
	};
}

export function handleShowOverlay(value) {
	return (dispatch) => {
		dispatch({
			type: "handleShowOverlay",
			value: value
		});
	};
}

export function clickOptionTime(value) {
	return (dispatch) => {
		dispatch({
			type: "clickOptionTime",
			value: value
		});
	};
}

export function handleMobileDraw(value) {
	return (dispatch) => {
		dispatch({
			type: "handleMobileDraw",
			value
		});
	};
}

export function handleShowBookDemo() {
	return (dispatch) => {
		dispatch({
			type: "handleShowBookDemo"
		});
	};
}

export function handlePriceAndSummaryMobileView(value) {
	return (dispatch) => {
		dispatch({
			type: "handlePriceAndSummaryMobileView",
			value
		});
	};
}

export function setManufacturer(id) {
	return (dispatch) => {
		dispatch({
			type: "handleSetManufacturer",
			id: id
		});
	};
}

export function handleShowShareModal() {
	return (dispatch) => {
		dispatch({
			type: "handleShowShareModal"
		});
	};
}

export function hasDoublelegBaiserail(e, buildingType, otherLegs) {
	return (dispatch) => {
		dispatch({
			type: "hasDoublelegBaiserail",
			event: e,
			buildingType: buildingType,
			otherLegs: otherLegs
		});
	};
}
export function showSingleSlope(key, e) {
	return (dispatch) => {
		dispatch({
			type: "showSingleSlope",
			event: e,
			key: key
		});
	};
}
export function Update_estimator_QuestionAnswer(e, key, key1, id, question_id, parentId) {
	return (dispatch) => {
		dispatch({
			type: "Update_estimator_QuestionAnswer",
			event: e,
			key: key,
			key1: key1,
			id: id,
			question_id: question_id,
			parentId: parentId
		});
	};
}
export function addCustomComponent(e, value, pos, dim) {
	return (dispatch) => {
		dispatch({
			type: "addCustomComponent",
			event: e,
			value: value,
			con: pos,
			dim: dim != undefined ? dim : ""
		});
	};
}

export function cloneComponent(uniqueid, doorObj) {
	return (dispatch) => {
		dispatch({
			type: "cloneComponent",
			uniqueid: uniqueid,
			doorObj: doorObj
		});
	};
}
export function changeProductStatus(e) {
	return (dispatch) => {
		dispatch({
			type: "changeProductStatus",
			event: e
		});
	};
}

export function handleClickForFrameValue(trimdoor, doorname, commonDoorType, doortype, uniqueId, dropdownType) {
	return (dispatch) => {
		dispatch({
			type: "handleClickForFrameValue",
			trimdoor: trimdoor,
			comName: doorname,
			comDoorType: commonDoorType,
			comType: doortype,
			comId: uniqueId,
			dropdownType: dropdownType
		});
	};
}
export function editComponentSize(trimdoor, doorname, commonDoorType, doortype, uniqueId, dropdownType) {
	return (dispatch) => {
		dispatch({
			type: "editComponentSize",
			trimdoor: trimdoor,
			comName: doorname,
			comDoorType: commonDoorType,
			comType: doortype,
			comId: uniqueId,
			dropdownType: dropdownType
		});
	};
}

export function headerSealChainHoistAction(event, value, UniqueId, bool_var, doorObj) {
	return (dispatch) => {
		dispatch({
			type: "headerSealChainHoistAction",
			event: event,
			value: value,
			UniqueId: UniqueId,
			bool_var: bool_var,
			componentObj: doorObj
		});
	};
}

export function onSubmitState(e) {
	return (dispatch) => {
		dispatch({
			type: "onSubmitState",
			event: e
		});
	};
}

export function showInsulationAction() {
	return (dispatch) => {
		dispatch({
			type: "showInsulationAction"
		});
	};
}

export function toggleActionForUtility(val) {
	return (dispatch) => {
		dispatch({
			type: "toggleActionForUtility",
			value: val
		});
	};
}
export function showCenterBuilding() {
	return (dispatch) => {
		dispatch({
			type: "showCenterBuilding"
		});
	};
}

export function wallSelection(key, value) {
	return (dispatch) => {
		dispatch({
			type: "wallSelection",
			key: key,
			value: value
		});
	};
}

export function handleLeanPorchPrices(leftFront, rightFront, leftBack, rightBack) {
	return (dispatch) => {
		batch(() => {
			if (leftFront) {
				dispatch(getPricingDataForLeanto("", "addFrontLean", params.lean_p_w, false, "checkLegs"));
				dispatch(getPricingDataForLeanto("", "addLeftLean", params.leanF_p_w, false, "checkLegs"));
			}
			if (rightFront) {
				dispatch(getPricingDataForLeanto("", "addFrontLean", params.leanR_p_w, false, "checkLegs"));
				dispatch(getPricingDataForLeanto("", "addRightLean", params.leanF_p_w, false, "checkLegs"));
			}
			if (leftBack) {
				dispatch(getPricingDataForLeanto("", "addBackLean", params.lean_p_w, false, "checkLegs"));
				dispatch(getPricingDataForLeanto("", "addLeftLean", params.leanB_p_w, false, "checkLegs"));
			}
			if (rightBack) {
				dispatch(getPricingDataForLeanto("", "addBackLean", params.leanR_p_w, false, "checkLegs"));
				dispatch(getPricingDataForLeanto("", "addRightLean", params.leanB_p_w, false, "checkLegs"));
			}
		});
	};
}

export function changeLeantoPosition({ event, value, skipCheck }) {
	return (dispatch) => {
		if (!skipCheck) {
			params.preAction = { event, value, type: "changeLeantoPosition" };
			dispatch({
				type: "checkChangeLeantoPosition",
				event,
				value
			});
		}

		if (!const_var.isShowAlert || skipCheck) {
			dispatch({
				type: "changeLeantoPosition",
				event,
				value
			});

			params.preAction = {};
		}
	};
}
export function ChangeLeanWidth(e, val) {
	return (dispatch) => {
		dispatch({
			type: "ChangeLeanWidth",
			value: e,
			num: val
		});
	};
}

export function CheckSnowLoadBuilding() {
	return (dispatch) => {
		dispatch({
			type: "CheckSnowLoadBuilding"
			// value:value
		});
		dispatch(changeBuildingData(const_var.AllBuildingData));
		const_var.checkmoreCustomizeFlag = false;
		let snowValChk = const_var.CheckSnowLoadValue == 65 ? 1 : 0;
		let filterResult = const_var.AllBuildingData.data.default_building.filter((data) => data.heavy_snow == snowValChk && data.image_name.includes("Garages.png"));
		if (filterResult.length == 0) {
			filterResult = const_var.AllBuildingData.data.default_building.filter((data) => data.heavy_snow == snowValChk && data.name.includes("RV Covers"));
		}
		dispatch(buildingStyleChange(filterResult[0].building_id, []));
	};
}

export function AddandRemoveComponent(e, key, index, typeMatch) {
	return {
		type: "AddandRemoveComponent",
		key: key,
		value: e.target.value,
		index: index,
		typeMatch: typeMatch
	};
}

export function TaxDepositCalculation(e, key, index) {
	return (dispatch) => {
		dispatch({
			type: "TaxDepositCalculation",
			value: e,
			key: key,
			index: index
		});
	};
}
export function commonsActionforAttribute(e, key, setZipCode = "") {
	return {
		type: "commonsActionforAttribute",
		value: e,
		key: key,
		setZipCode: setZipCode
	};
}
export function handleShowFullPageLoader() {
	return (dispatch) => {
		dispatch({
			type: "handleShowFullPageLoader"
		});
	};
}
export function callTaxApiAndCalculatePrice(e) {
	return (dispatch) => {
		if (e != undefined) {
			dispatch({
				type: "callTaxApiAndCalculatePrice",
				value: e,
				key: "add_zipcode"
			});
		}
		if (params.tax_zipcode.length >= 4) {
			setTimeout(() => {
				let zipData = { zip_code: params.tax_zipcode };
				return taxFromZip(zipData).then((response) => {
					if (response?.data?.status == true && const_var.MoreTaxinputs.length > 0) {
						const_var.MoreTaxinputs = [];
					}
					if (response?.data?.status == true && response?.data?.length <= 0 && response?.data?.tax_data != null) {
						const_var.tax.percentage = 0;
					}
					dispatch({
						type: "callTaxApiAndCalculatePrice",
						value: response.data,
						newvalue: response.data.tax_data != undefined ? response.data.tax_data : "",
						key: "calculate_zipcode"
					});
				});
			}, 300);
		} else {
			const_var.tax.amount = 0;
		}
	};
}

export function changeComponent(doorName, uniqueId, component_Obj) {
	return (dispatch) => {
		let dwIconsDiv = document.getElementById("doorwindowicons");
		dwIconsDiv && dwIconsDiv.classList.add("d-none");
		dispatch({
			type: "changeComponent",
			doorName,
			uniqueId: uniqueId,
			component_Obj: component_Obj
		});
	};
}

export function changeComponentSize(doorsize, uniqueId, component_Obj, is_trim, is_Checked) {
	return (dispatch) => {
		let dwIconsDiv = document.getElementById("doorwindowicons");
		dwIconsDiv && dwIconsDiv.classList.add("d-none");
		dispatch({
			type: "changeComponentSize",
			doorsize: doorsize,
			uniqueId: uniqueId,
			component_Obj: component_Obj,
			is_trim: is_trim,
			is_Checked: is_Checked
		});
	};
}

export function clearComponents(e) {
	return (dispatch) => {
		dispatch({
			type: "clearComponents",
			value: e
		});
	};
}
export function ChangeBackgroundAccordingtoCon(e) {
	return (dispatch) => {
		dispatch({
			type: "ChangeBackgroundAccordingtoCon",
			value: e
		});
	};
}
export function ShowMeasure(key, e) {
	return {
		type: "ShowMeasure",
		key: key,
		value: e
	};
}

export function changeOtherBuildingTypeName(e, other) {
	return {
		type: "changeOtherBuildingTypeName",
		value: e,
		other: other
	};
}
export function commonConfirmationAlert(key) {
	return {
		type: "commonConfirmationAlert",
		key: key
	};
}
export function genratePrintImages(value) {
	return {
		type: "genratePrintImages",
		payload: value
	};
}
export function capturebuildingImages(val, chkIndex) {
	return {
		type: "capturebuildingImages",
		val: val,
		chkIndex: chkIndex
	};
}

export function manageSideLeanUI(e, val) {
	return {
		type: "manageSideLeanUI",
		event: e,
		value: val
	};
}
export function showMoreLessSidesAndEnds(position) {
	return (dispatch) => {
		dispatch({
			type: "showMoreLessSidesAndEnds",
			position: position
		});
	};
}
export function ShowHideTranslusant(val, key) {
	return (dispatch) => {
		dispatch({
			type: "ShowHideTranslusant",
			value: val,
			key: key
		});
	};
}
export function updatePaymentOption(event, key) {
	return (dispatch) => {
		dispatch({
			type: "updatePaymentOption",
			event: event,
			key: key
		});
	};
}
export function orderExtrasChangeValueFromMainAction(e, name, keyword) {
	return (dispatch) => {
		dispatch({
			type: "orderExtrasChangeValue",
			event: e,
			value: name,
			keyword: keyword
		});
	};
}

export function handleBreezawayFrameAndStorages(e, option) {
	return (dispatch) => {
		dispatch({
			type: "handleBreezawayFrameAndStorages",
			value: e,
			option: option
		});
	};
}

export function addDoorComponent(compType, compName, wall, componentsize, arraykey1, arraykey2, arraykey3, obj) {
	return (dispatch) => {
		dispatch({
			type: "ADD_DOOR_COMPONENT",
			compType,
			compName,
			wall,
			componentsize: componentsize,
			parentkey: arraykey1,
			childkey: arraykey2,
			nestedkey: arraykey3,
			obj: obj
		});
	};
}

export function cameraFocusOnWall(wall) {
	return (dispatch) => {
		dispatch({
			type: "CAMERA_FOCUS_ON_WALL",
			value: wall
		});
	};
}
export function handleIconClick(e, id, type) {
	return (dispatch) => {
		dispatch({
			type: "handleIconClick",
			event: e,
			doorUniqueId: id,
			value: type
		});
	};
}
export function showDoorWindowsPrompt(compType, compName, width, height, wallName) {
	return {
		type: "showDoorWindowsPrompt",
		compType: compType,
		compName: compName,
		width: width,
		height: height,
		wallName: wallName
	};
}
export function setPricingForComponent(flag, id, indexVal, chk, is_editChk) {
	return {
		type: "setPricingForComponent",
		flag: flag,
		id: id,
		indexVal: indexVal,
		chk: chk,
		is_editChk: is_editChk
	};
}
export function setPricingForSurcharge(value) {
	return {
		type: "setPricingForSurcharge",
		value: value
	};
}
export function changeBuildingOnCenter(val, action) {
	return (dispatch) => {
		dispatch({
			type: "changeBuildingOnCenter",
			value: val,
			actionType: action
		});
	};
}

export function CheckSharingAlertBox(val) {
	return (dispatch) => {
		dispatch({
			type: "CheckSharingAlertBox",
			value: val
		});
	};
}

export function isOpenBookaDemo(val) {
	return (dispatch) => {
		dispatch({
			type: "isOpenBookaDemo",
			value: val
		});
	};
}

export function UsertourAction(val, key, opennumber) {
	return (dispatch) => {
		dispatch({
			type: "UsertourAction",
			value: val,
			key: key,
			opennumber: opennumber
		});
	};
}

export function isOpenWelcomeModal(val, key) {
	return (dispatch) => {
		dispatch({
			type: "isOpenWelcomeModal",
			value: val,
			key: key
		});
	};
}

export function isOpenLayoutDesignModal(val, key) {
	return (dispatch) => {
		dispatch({
			type: "isOpenLayoutDesignModal",
			value: val,
			key: key
		});
	};
}

export function publicEditFun(val, key) {
	document.querySelector("body").classList.add("customer-edit-loader");
	return (dispatch) => {
		var apiUrl = const_var.crmSetting.api_post_url + "/api/v1/3d-public/edit-start";
		return axios
			.post(apiUrl, { module_string: const_var.isPublicModuleID })
			.then(function (response) {
				if (response.data.status == true) {
					const stateId = params.p_s_n;

					const selectedState = const_var.bjDData.find((state) => state.id == stateId);

					if (selectedState && selectedState?.manufacturer_list?.price_comparision?.length > 0) {
						const key = `selectedState_${stateId}`;
						let mfgList = [selectedState?.manufacturer_list, ...selectedState?.manufacturer_list?.price_comparision];

						const_var.hideCompareOption = false;
						dispatch(savePriceComparisionDataForNotLoggedIn(key, mfgList));
					} else {
						const_var.hideCompareOption = true;
					}

					dispatch({
						type: "publicEditFun",
						value: val,
						key: key
					});
					document.querySelector("body").classList.remove("customer-edit-loader");
				}
			})
			.catch(function (error) {
				dispatch({
					type: "publicEditFun",
					value: error.response.data.message,
					key: key,
					actionType: "error"
				});
				document.querySelector("body").classList.remove("customer-edit-loader");
			});
	};
}
export function submitReportIssue(desc, url, screenShot) {
	if (desc && desc != "") {
		return (dispatch) => {
			let timestamp = new Date().getTime();
			dispatch({
				type: "handleReportLoader",
				value: true
			});
			let postData = {
				api_token: const_var.crmSetting.api_token,
				user_id: const_var.crmSetting.login_user_id != undefined ? const_var.crmSetting.login_user_id : "",
				title: "Report this issue : 3D",
				description: desc,
				current_url: url,
				timestamp: timestamp,
				last_activity: "",
				region_state: const_var.stateNameAcordingAPI[params.p_s_n],
				building_type: params.building_type_name,
				manufacturer_name: const_var.stateManufacturerAcordingAPIDiscount["manuName"][params.m_s_n],
				map_id: const_var.Map_Id[params.p_b_t],
				type: "3d_issue",
				attachments: [
					{
						file: screenShot,
						file_name: "report"
					}
				]
			};
			return axios
				.post(const_var.crmSetting.api_post_url + "/api/v1/tickets/report_issue", postData)
				.then(function (response) {
					if (response.data.status == true) {
						dispatch({
							type: "submitReportIssue",
							response: response.data
						});
						dispatch({
							type: "handleReportLoader",
							value: false
						});
					} else {
						dispatch({
							type: "submitReportIssue",
							errormsg: response.data.message
						});
						dispatch({
							type: "handleReportLoader",
							value: false
						});
					}
				})
				.catch(function (error) {
					dispatch({
						type: "submitReportIssue",
						errormsg: "Server Error. Please try again later."
					});
					dispatch({
						type: "handleReportLoader",
						value: false
					});
				});
		};
	} else {
		return (dispatch) => {
			dispatch({
				type: "submitReportIssue",
				response: ""
			});
		};
	}
}
export function manageReportIssueModal(show) {
	return (dispatch) => {
		dispatch({
			type: "manageReportIssueModal",
			value: show
		});
	};
}
export function ManageKlinkExpire(data) {
	return (dispatch) => {
		dispatch({
			type: "ManageKlinkExpire",
			value: data
		});
	};
}
export function setScreenShot(val) {
	return (dispatch) => {
		dispatch({
			type: "setScreenShot",
			value: val
		});
	};
}

export function resetErrorMsg(key) {
	return (dispatch) => {
		dispatch({
			type: "resetErrorMsg",
			response: "",
			key: key
		});
	};
}
export function zipCodeError(msg) {
	return (dispatch) => {
		dispatch({
			type: "zipCodeError",
			msg: msg
		});
	};
}
export function showStateField(val, apiCallForStateVal = "") {
	return (dispatch) => {
		dispatch({
			type: "showStateField",
			value: val,
			apiCallForStateVal: apiCallForStateVal
		});
	};
}
export function handleDescription(val) {
	return (dispatch) => {
		dispatch({
			type: "handleDescription",
			value: val
		});
	};
}
export function handleReportLoader(val) {
	return (dispatch) => {
		dispatch({
			type: "handleReportLoader",
			value: val
		});
	};
}
export function updatePreQuoteErr(val, resetState = false) {
	return (dispatch) => {
		dispatch({
			type: "updatePreQuoteErr",
			value: val,
			resetState: resetState
		});
	};
}
export function updatePostData() {
	return (dispatch) => {
		dispatch({
			type: "updatePostData"
		});
	};
}
export const toggleCustomCheckboxChange = (key) => {
	return (dispatch) => {
		dispatch({
			type: "toggleCustomCheckboxChange",
			key: key
		});
	};
};
export const activeTabPanel = (value, key, flag) => {
	return (dispatch) => {
		dispatch({
			type: "handleProfileModal",
			value: false
		});

		dispatch({
			type: "activeTabPanel",
			value: value,
			key: key,
			flag: flag
		});
	};
};
export const setBuildingFlags = (key, value, exactValue) => {
	return (dispatch) => {
		dispatch({
			type: "setBuildingFlags",
			key: key,
			value: value,
			exactValue: exactValue
		});
	};
};

export const handleProfileModal = (value) => {
	return (dispatch) => {
		dispatch({
			type: "handleProfileModal",
			value: value
		});
	};
};

export const handleFeedbackMandatory = (value) => {
	return (dispatch) => {
		dispatch({
			type: "handleFeedbackMandatory",
			value: value
		});
	};
};
export const setNavtab = (key, value) => {
	return (dispatch) => {
		dispatch({
			type: "setNavtab",
			key: key,
			value: value
		});
	};
};
export const fullyWrapClick = (key, value) => {
	return (dispatch) => {
		dispatch({
			type: "fullyWrapClick",
			key: key,
			value: value
		});
	};
};

// ############### Action to handle Modal on change of state and manufacture #################
export function showStateOrManufactureChangeModal(val, id, flag) {
	return (dispatch) => {
		dispatch({
			type: "showStateOrManufactureChangeModal",
			value: val,
			id: id,
			flag: flag
		});
	};
}

// ############### Action to handle click on zipcode tool tip #################
export function handleToolTip() {
	return (dispatch) => {
		dispatch({
			type: "handleToolTip"
		});
	};
}

export function handleStateManufactureChange(key, value) {
	return (dispatch) => {
		dispatch({
			type: "handleStateManufactureChange",
			key: key,
			value: value
		});
	};
}

export function GlobalZipUpdate(value) {
	return (dispatch) => {
		dispatch({
			type: "GlobalZipUpdate",
			value: value
		});
	};
}
export function handleOfferPriceCalculation(value) {
	return (dispatch) => {
		dispatch({
			type: "handleOfferPriceCalculation",
			value: value
		});
	};
}
export function fullViewbuild() {
	return (dispatch) => {
		dispatch({
			type: "fullViewbuild"
		});
	};
}

export function updateGableBackWall(value) {
	return (dispatch) => {
		dispatch({
			type: "updateGableBackWall",
			value: value
		});
	};
}

export function resetDiscountNew(expired) {
	return (dispatch) => {
		dispatch({
			type: "resetDiscountNew",
			expired: expired
		});
	};
}

export function handleDealerDiscountBannerVisible(value) {
	return (dispatch) => {
		dispatch({
			type: "handleDealerDiscountBannerVisible",
			value: value
		});
	};
}

export function handleCompanySelection(id, from) {
	return (dispatch) => {
		dispatch({
			type: "handleCompanySelection",
			value: id,
			from: from
		});

		if (from == "state") {
			dispatch(getDealerStateList(false, true, "", false));
		}
		if (from == "tooltip") {
			dispatch(getDealerStateList(false, true, "", true));
		}
	};
}

export function handleDeletedStateManuModal(value) {
	return (dispatch) => {
		dispatch({
			type: "handleDeletedStateManuModal",
			value: value
		});
	};
}

export const handleShowAlertBox = (value) => {
	return (dispatch) => {
		dispatch({
			type: "handleShowAlertBox",
			value: value
		});
	};
};

export const handleLoftChange = (value, index, isFor = "center", label) => {
	return (dispatch) => {
		dispatch({
			type: "handleLoftChange",
			value: value,
			index: index,
			isFor: isFor,
			label: label
		});
	};
};
